import {destandard} from '../utils/commonFunctions';

export const GET_GROUPS_PENDING = 'GET_GROUPS_PENDING';
export const GET_GROUPS_FETCHED = 'GET_GROUPS_FETCHED';
export const GET_ALL_GROUPS_FETCHED = 'GET_ALL_GROUPS_FETCHED';
export const GET_GROUPS_REJECTED = 'GET_GROUPS_REJECTED';
export const GET_GROUP_PENDING = 'GET_GROUP_PENDING';
export const GET_GROUP_FETCHED = 'GET_GROUP_FETCHED';
export const GET_GROUP_REJECTED = 'GET_GROUP_REJECTED';
export const DELETE_GROUP_REJECTED = 'DELETE_GROUP_REJECTED';
export const DELETE_GROUP_FETCHED = 'DELETE_GROUP_FETCHED';
export const DELETE_GROUP_PENDING = 'DELETE_GROUP_PENDING';


const initialState = {
  meta: {
    current_page: 1,
    per_page: 10,
  },
  groups: [],
  group: {},
  fetching: false,
  fetched: false,
  errors: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_GROUPS_PENDING:
    case GET_GROUP_PENDING: {
      return {...state, fetching: true, fetched: false};
    }
    case GET_GROUPS_FETCHED: {
      return {
        ...state,
        fetching: false,
        fetched: true,
        groups: action.payLoad.data,
        meta: destandard(action.payLoad.meta)
      };
    }
    case GET_ALL_GROUPS_FETCHED: {
      return {
        ...state,
        fetching: false,
        fetched: true,
        groups: action.payLoad.data
      };
    }
    case GET_GROUP_FETCHED: {
      return {
        ...state,
        fetching: false,
        fetched: true,
        group: action.payLoad.data,
      };
    }
    case DELETE_GROUP_FETCHED: {
      return {
        ...state,
      };
    }
    case GET_GROUP_REJECTED: {
      return {
        ...state, fetching: false, fetched: false, group: {}
      };
    }
    case GET_GROUPS_REJECTED: {
      return initialState;
    }
    default: return {...state};
  }
};
